import React from 'react'
import { ScreeningQuestion } from '../../../types/sponsorships/campaigns'
import './style.scss'

const ScreeningQuestionMCQ: React.FC<{
    index: number
  question: ScreeningQuestion
    value: string | number
    onChange: (value: string) => void
    highlightError?: boolean
}> = ({ index, question, value, onChange, highlightError }) => {
  const options = question.options ?? []
  const groupName = `screening-mcq-${question.id}`

  return (
    <div className="screening-mcq">
      <h3 className="screening-mcq__title fw-600 text-dark fs-16" id={`${groupName}-label`}>
        {index + 1}. {question.question}
      </h3>
      <div
        className="screening-mcq__options gap-2"
        role="radiogroup"
        aria-labelledby={`${groupName}-label`}
      >
        {options.map((option) => {
          const selected = value === option
          return (
            <label
              key={option}
              className={`screening-mcq__option fw-400 fs-14 text-dark${selected ? ' is-selected' : ''}`}
            >
              <span className="screening-mcq__option-text">{option}</span>
              <span className="screening-mcq__radio" aria-hidden={true}>
                <span className="screening-mcq__radio-dot" />
              </span>
              <input
                type="radio"
                className="visually-hidden"
                name={groupName}
                value={option}
                checked={selected}
                onChange={() => onChange(option)}
              />
            </label>
          )
        })}
      </div>
      {highlightError && <div className="text-danger fs-14 mt-2">Please select a valid option</div>}
    </div>
  )
}

export default ScreeningQuestionMCQ
